// jshint esversion: 8
const now = () => new Date()
const timeSinceMidnight = () => now().getTime() - new Date(now().getFullYear(), now().getMonth(), now().getDate())

export default (n) => new Date(now().setDate(now().getDate() - n) - timeSinceMidnight())
